document.addEventListener("DOMContentLoaded", function (e) {
  // Upsell Script Start
  var step_target = document.querySelectorAll("[JSMatchStepInit]"),
    upsell_item_add = document.querySelectorAll("[JSADDItemRoutineInit]"),
    upsell_add = document.querySelectorAll("[JSEnabledUpsellAdd]");
  if (step_target.length > 0) {
    step_target.forEach(function (step) {
      step.addEventListener("click", function (e) {
        e.preventDefault();
        var target_tab = this.getAttribute("href"),
          target_index = this.dataset.index;
        this.closest(".UpsellContentStepsWrpr")
          .querySelectorAll("[JSMatchStepInit]")
          .forEach(function (target) {
            target.parentNode.classList.remove("active");
          });
        this.parentNode.classList.add("active");
        document.querySelectorAll("[JSItemTabLooper]").forEach(function (tab) {
          tab.classList.remove("active");
        });
        if (document.querySelector(target_tab)) {
          document.querySelector(target_tab).classList.add("active");
        }
      });
    });
  }

  var upsell_bundle_id = [],
    upsell_bundle_price = [],
    upsell_bundle_cmprice = [],
    items_json = [];
  let final_price = 0,
    final_cmprice = 0;

  if (upsell_item_add.length > 0) {
    upsell_item_add.forEach(function (item) {
      item.addEventListener("change", function (e) {
        if (this.checked == true) {
          var variant_value = this.value,
            variant_price = parseInt(this.dataset.price),
            variant_cmp = parseInt(this.dataset.comparePrice);
          upsell_bundle_id.push(variant_value);
          upsell_bundle_price.push(variant_price);
          upsell_bundle_cmprice.push(variant_cmp);
        } else {
          var upsell_value_index = upsell_bundle_id.indexOf(this.value),
            upsell_value_index_price = upsell_bundle_price.indexOf(
              parseInt(this.dataset.price)
            );
          if (upsell_value_index > -1) {
            upsell_bundle_id.splice(upsell_value_index, 1);
          }
          if (upsell_value_index_price > -1) {
            upsell_bundle_price.splice(upsell_value_index_price, 1);
          }
          var upsell_value_index_cmp = upsell_bundle_cmprice.indexOf(
            parseInt(this.dataset.comparePrice)
          );
          if (upsell_value_index_cmp > -1) {
            upsell_bundle_cmprice.splice(upsell_value_index_cmp, 1);
          }
          final_price = 0;
          final_cmprice = 0;
        }
        if (upsell_bundle_id.length > 0) {
          this.closest(".UpsellContentStepsMN")
            .querySelector(".ItemsSelectedCount")
            .classList.remove("hide");
          upsell_add.removeAttribute("disable");
          this.closest(".UpsellContentStepsMN").querySelector(
            ".ItemsSelectedCount .ItemsCount"
          ).innerHTML = upsell_bundle_id.length;
          document.querySelector(".ItemsIntialMsg").classList.add("hide");
        } else {
          document.querySelector(".ItemsSelectedCount").classList.add("hide");
          document.querySelector(".ItemsIntialMsg").classList.remove("hide");
          upsell_add.setAttribute("disable", "disable");
        }
        if (upsell_bundle_price.length > 0) {
          upsell_bundle_price.forEach(function (price) {
            final_price += parseInt(price);
          });
          final_price = final_price / 100;
          this.closest(".UpsellContentStepsMN").querySelector(
            ".SalePriceUpsell"
          ).innerHTML = "₹" + final_price;
        }
        if (upsell_bundle_cmprice.length > 0) {
          upsell_bundle_cmprice.forEach(function (cmprice) {
            final_cmprice += parseInt(cmprice);
          });
          final_cmprice = final_cmprice / 100;
          this.closest(".UpsellContentStepsMN").querySelector(
            ".RegPriceUpsell s"
          ).innerHTML = "₹" + final_cmprice;
        }
        final_price = 0;
        final_cmprice = 0;
      });
    });
  }

  if (upsell_add.length > 0) {
    upsell_add.forEach(function (upsell) {
      upsell.addEventListener("click", function (e) {
        e.preventDefault();
        console.log(
          upsell
            .closest(".UpsellContentStepsMN")
            .querySelectorAll("[JSADDItemRoutineInit]").length
        );
        if (upsell_bundle_id.length > 0) {
          upsell_bundle_id.forEach(function (variant_id) {
            items_json.push({ id: variant_id, quantity: 1 });
          });
          let formData = { items: items_json, sections: "" };
          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              return response.json();
            })
            .finally(() => {
              document.querySelector(".site-header__cart-toggle").click();
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        } else if (
          upsell
            .closest(".UpsellContentStepsMN")
            .querySelectorAll("[JSADDItemRoutineInit]").length > 0
        ) {
          upsell
            .closest(".UpsellContentStepsMN")
            .querySelectorAll("[JSADDItemRoutineInit]")
            .forEach(function (input) {
              if (input.checked == true) {
                items_json.push({ id: input.value, quantity: 1 });
              }
            });
          let formData = { items: items_json, sections: "" };
          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              return response.json();
            })
            .finally(() => {
              document.querySelector(".site-header__cart-toggle").click();
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      });
    });
  }
  // Upsell Script End

  // Handles all "add to cart" clicks within the dynamic product tab using event delegation
  document.addEventListener("click", function(e) {
    // Check if a button inside the product tab was clicked
    var button = e.target.closest('[JSUpdateProductsTab] .CardListProductWrpr button[type="submit"]');
    if (button) {
      e.preventDefault();
      console.log("Adding to cart:", button.dataset.id);

      let formTabData = {
        items: [{ id: button.dataset.id, quantity: 1 }],
      };

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formTabData),
      })
      .then(response => response.json())
      .finally(() => {
        // This function was in the original code, so we keep it.
        if (typeof handleFloCartBtn === 'function') {
          handleFloCartBtn();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    }
  });

  var upsell_tab_slider = new Swiper(".swiper[JSSliderUpsell]", {
    slidesPerView: 1.3,
    spaceBetween: 20,
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 1.6,
      },
      0: {
        slidesPerView: 1.2,
        spaceBetween: 10,
      },
    },
    on: {
      init: function (swiper) {
        swiper.el
          .closest(".UpsellContentStepsWrpr")
          .querySelectorAll("[JSMatchStepInit]")
          .forEach(function (step) {
            step.addEventListener("click", function (e) {
              swiper.slideTo(this.dataset.index);
            });
          });
      },
      slideChange: function (swiper) {
        swiper.el
          .closest(".UpsellContentStepsWrpr")
          .querySelectorAll("[JSMatchStepInit]")
          .forEach(function (step) {
            step.parentNode.classList.remove("active");
          });
        swiper.el
          .closest(".UpsellContentStepsWrpr")
          .querySelector(
            '[JSMatchStepInit][data-index="' + swiper.activeIndex + '"]'
          )
          .parentNode.classList.add("active");
      },
    },
  });

  function swiper_slide(index) {
    document.querySelectorAll(".UpsellContentStepsMN").forEach(function (tab) {
      tab.classList.remove("active");
    });
    if (
      document.querySelector(
        '.UpsellContentStepsMN[data-index-slide="' + index + '"]'
      )
    ) {
      document
        .querySelector(
          '.UpsellContentStepsMN[data-index-slide="' + index + '"]'
        )
        .classList.add("active");
    }
  }

  var shop_tab_slider = new Swiper(".ShopByTabSlideWrpr.swiper", {
    slidesPerView: 3,
    loopAdditionalSlides: 1,
    spaceBetween: 20,
    loop: true,
    freeMode: false,
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 3,
      },
      0: {
        slidesPerView: 2.5,
        spaceBetween: 10,
      },
    },
    on: {
      init: function (swiper) {
        if (swiper.slides[swiper.activeIndex].hasAttribute("JSFindProducts")) {
          fetch(
            swiper.slides[swiper.activeIndex].getAttribute("data-url") +
              "?section_id=product_card_global"
          )
            .then((response) => response.text())
            .then((data) => {
              const productsList = new DOMParser()
                .parseFromString(data, "text/html")
                .querySelector(".shopify-section").innerHTML;
              document.querySelector("[JSUpdateProductsTab]").innerHTML =
                productsList;
            });
          document.querySelector(".ProductListHeader h2").innerHTML =
            "Shop the " +
            swiper.slides[swiper.activeIndex].querySelector(".typeTitleMN")
              .innerHTML +
            " range";
        }
      },
      click: function (swiper) {
        swiper.slideToLoop(swiper.clickedSlide.dataset.swiperSlideIndex);
        swiper.slides.forEach(function (slide) {
          slide.classList.remove("active");
        });
        if (swiper.clickedSlide.hasAttribute("JSFindProducts")) {
        } else {
          swiper_slide(swiper.realIndex);
          swiper.clickedSlide.classList.add("active");
        }
      },
      slideChange: function (swiper) {
        swiper.slides.forEach(function (slide) {
          slide.classList.remove("active");
        });
        if (swiper.slides[swiper.activeIndex].hasAttribute("JSFindProducts")) {
          fetch(
            swiper.slides[swiper.activeIndex].getAttribute("data-url") +
              "?section_id=product_card_global"
          )
            .then((response) => response.text())
            .then((data) => {
              setTimeout(function () {
                const productsList = new DOMParser()
                  .parseFromString(data, "text/html")
                  .querySelector(".shopify-section").innerHTML;
                document.querySelector("[JSUpdateProductsTab]").innerHTML =
                  productsList;
                // The new global handler at the top of the script now handles this automatically.
                // No code is needed here.
              }, 600);
            });
          document.querySelector(".ProductListHeader h2").innerHTML =
            "Shop the " +
            swiper.slides[swiper.activeIndex].querySelector(".typeTitleMN")
              .innerHTML +
            " range";
        } else {
          swiper_slide(swiper.activeIndex);
          swiper.slides[swiper.activeIndex].classList.add("active");
        }
        document
          .querySelectorAll("[JSADDItemRoutineInit]")
          .forEach(function (input) {
            if (input.checked == true) {
              input
                .closest(".UpsellContentStepsMN")
                .querySelector(".ItemsSelectedCount")
                .classList.add("hide");
              // input.checked = false;
              (upsell_bundle_id = []),
                (upsell_bundle_price = []),
                (upsell_bundle_cmprice = []),
                (items_json = []);
            }
          });
        swiper_slide(swiper.realIndex);
      },
    },
  });

  // Featured Section and Why US Script Start
  var play_button = document.querySelectorAll("[JSPLAYVideoInit]");
  if (play_button.length > 0) {
    play_button.forEach(function (play) {
      play.addEventListener("click", function (e) {
        e.preventDefault();
        document
          .querySelectorAll("[JSParentTarget] video")
          .forEach(function (video) {
            video.closest("[JSParentTarget]").classList.remove("active");
            video.pause();
          });
        this.parentNode.classList.add("active");
        if (window.innerWidth <= 767) {
          this.parentNode.querySelector("video.mobile-only").play();
          this.parentNode.querySelector("video.desktop-only").pause();
        } else {
          this.parentNode.querySelector("video.desktop-only").play();
          this.parentNode.querySelector("video.mobile-only").pause();
        }
      });
    });
  }
  // Featured Section and Why US Script End
});